import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { EQUIPMENT_TYPES } from "constants/equipmentTypes";
import SmallText from "../../../../Typography/SmallText";
import NormalText from "../../../../Typography/NormalText";

const ContainerStyled = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "start",
  "& p": {
    maxWidth: "100%",
  },
  "& .tool-type": {
    fontWeight: 300,
  },
});

const EquipmentItem = ({ equipment }) => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language.startsWith("en");

  const equipmentType =
    equipment.machineryRead.machineryType === EQUIPMENT_TYPES.MACHINE
      ? t("Equipment.Machine")
      : t("Equipment.Tool");
  const equipmentName = isEn
    ? equipment.machineryRead.nameEn
    : equipment.machineryRead.nameGr;

  return (
    <ContainerStyled>
      <SmallText text={equipmentType} className="tool-type" />
      <NormalText text={equipmentName} className="text-truncate" />
    </ContainerStyled>
  );
};

export default EquipmentItem;
